import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { Module } from '../../interfaces';
import { UiServices } from 'src/app/services/ui-services';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { ModuleTestService } from '../services/module-test.service';
import { UnavailableTestComponent } from './module-show-components/unavailable-test/unavailable-test.component';

@Component({
  selector: 'app-module-show',
  templateUrl: './module-show.page.html',
  styleUrls: ['./module-show.page.scss'],
})
export class ModuleShowPage {
  public module?: Module = undefined;
  public loading = true;
  public inscriptionId = '';

  constructor(
    private httpSv: HttpService,
    private route: ActivatedRoute,
    private uiSv: UiServices,
    private paramSv: ParamServicesService,
    private moduleTestSv: ModuleTestService
  ) {}

  ionViewDidEnter() {
    this.getModule();
  }

  async getModule() {
    await this.uiSv.showLoading();
    this.inscriptionId = this.route.snapshot.paramMap.get('incription_id');
    const id = this.route.snapshot.paramMap.get('module_id');
    const res = await this.httpSv.itemIndex(
      'learningModules',
      '',
      { inscriptionId: this.inscriptionId },
      `show/${id}`
    );
    await this.uiSv.loading?.dismiss();
    if (!res.status) {
      if (!Object.values(this.paramSv.headerParams).length) {
        const obs = this.paramSv.emitImagesObs.subscribe((data) => {
          if (data === 'finish') {
            this.moduleTestSv.showReasonModal(res.data, this.inscriptionId);
            obs.unsubscribe();
          }
        });
      } else {
        this.moduleTestSv.showReasonModal(res.data, this.inscriptionId);
      }
      return;
    }
    this.module = res.data;
    if (this.module.moduleEnd) {
      if (!Object.values(this.paramSv.headerParams).length) {
        const obs = this.paramSv.emitImagesObs.subscribe((data) => {
          if (data === 'finish') {
            this.showCongrats();
            obs.unsubscribe();
          }
        });
      } else {
        this.showCongrats();
      }
    }
    this.loading = false;
  }

  async showCongrats() {
    await this.uiSv.showModal(UnavailableTestComponent, {}, 'continue-to-pay');
  }
}
